import { BodyNormal, LinkButton } from '@atlassian/mpac-primitives';
import { CloudFortifiedInfoModal } from '@atlassian/mpac-ui';
import React, { useState } from 'react';
import { usePrivacyAndSecurityAnalytics } from '../../hooks';
import { ContentHeader, ContentItems, ContentWrapper, Heading, Label } from './Certification.styles';
import FortifiedIcon from '../../assets/fortified.svg';
import ReliabilityIcon from '../../assets/reliability.svg';
import ShieldIcon from '../../assets/shield.svg';
import SupportIcon from '../../assets/support.svg';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const CloudFortifiedContent = _ref => {
  let {
    appName,
    partnerName,
    partnerUrl
  } = _ref;
  const {
    fireViewDetailsEvent
  } = usePrivacyAndSecurityAnalytics();
  const [showCloudFortifiedModal, setShowCloudFortifiedModal] = useState(false);
  const toggleCloudFortifiedModal = () => setShowCloudFortifiedModal(prev => !prev);
  const onMoreDetailsClicked = () => {
    toggleCloudFortifiedModal();
    fireViewDetailsEvent('Atlassian trust programs - more details');
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ContentHeader, {
      children: [/*#__PURE__*/_jsx("img", {
        "aria-label": "Cloud Fortified badge",
        src: FortifiedIcon,
        alt: "fortified-icon"
      }), /*#__PURE__*/_jsx(Heading, {
        children: "CLOUD FORTIFIED"
      })]
    }), /*#__PURE__*/_jsxs(ContentWrapper, {
      children: [/*#__PURE__*/_jsx(BodyNormal, {
        children: "This app offers additional security, reliability, and support through:"
      }), /*#__PURE__*/_jsxs(ContentItems, {
        children: [/*#__PURE__*/_jsxs(ContentHeader, {
          children: [/*#__PURE__*/_jsx("img", {
            src: ShieldIcon,
            alt: "shield-icon"
          }), /*#__PURE__*/_jsx(Label, {
            children: "Cloud security participation"
          })]
        }), /*#__PURE__*/_jsxs(ContentHeader, {
          children: [/*#__PURE__*/_jsx("img", {
            src: ReliabilityIcon,
            alt: "reliability-icon"
          }), /*#__PURE__*/_jsx(Label, {
            children: "Timely reliability checks"
          })]
        }), /*#__PURE__*/_jsxs(ContentHeader, {
          children: [/*#__PURE__*/_jsx("img", {
            src: SupportIcon,
            alt: "support-icon"
          }), /*#__PURE__*/_jsx(Label, {
            children: "24hr support response time"
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(LinkButton, {
      "aria-label": "More details about the cloud fortified program",
      "aria-haspopup": true,
      onClick: onMoreDetailsClicked,
      children: "More details"
    }), showCloudFortifiedModal && /*#__PURE__*/_jsx(CloudFortifiedInfoModal, {
      appName: appName,
      partnerUrl: partnerUrl,
      isOpen: showCloudFortifiedModal,
      onClose: toggleCloudFortifiedModal,
      partnerName: partnerName
    })]
  });
};